<ion-button
	[class.app-cta-button]="true"
	[class.app-cta-button--full]="fullWidth()"
	[class.app-cta-button--min-sm]="minWidth() === 'sm'"
	[class.app-cta-button--min-md]="minWidth() === 'md'"
	[class.app-cta-button--min-lg]="minWidth() === 'lg'"
	[color]="color()"
	[fill]="fill()"
	[shape]="shape()"
	[size]="size()"
	[expand]="expand()"
	[type]="type()"
	[disabled]="disabled()"
	[routerLink]="routerLink()"
>
	<ng-content></ng-content>
	@if (label()) {
		<span>{{ label() }}</span>
	}
</ion-button>
